import React from "react";
import PropTypes from "prop-types";
var ConsentBannerQuickAccess = function (props) {
    var children = props.children, quickAccessLabel = props.quickAccessLabel;
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { className: "fr-footer__bottom-link", "data-fr-opened": "false", "aria-controls": "fr-consent-modal" }, quickAccessLabel),
        children));
};
ConsentBannerQuickAccess.defaultProps = { __TYPE: "ConsentBannerQuickAccesss" };
ConsentBannerQuickAccess.propTypes = { __TYPE: PropTypes.string };
export default ConsentBannerQuickAccess;
